import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { contactsApi } from '@/api/contacts';
import { ContactForm } from '@/components/contacts/ContactForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function NewContactPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: {
    name: string;
    type: 'email' | 'phone' | 'telegram';
    email?: string | null;
    phone_number?: string | null;
    telegram_chat_id?: string | null;
  }) => {
    setIsSubmitting(true);
    setError(null);
    try {
      await contactsApi.create(data);
      navigate('/dashboard/contacts');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create contact');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard/contacts');
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <Link
          to="/dashboard/contacts"
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Contacts
        </Link>
      </div>

      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Add New Contact</CardTitle>
        </CardHeader>
        <CardContent>
          {error ? (
            <div className="mb-4 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {error}
            </div>
          ) : null}
          <ContactForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </div>
  );
}
